// Copyright (c) 2020-2024 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import Grid, { GridProps } from '@material-ui/core/Grid';
import { Grid, GridProps } from '@mui/material';

export interface FlexProps extends GridProps {
  autoWidth?: boolean;
}

const Flex: React.FC<FlexProps> = ({ autoWidth = true, ...otherProps }) => {
  return <Grid style={autoWidth ? { width: 'auto' } : {}} container {...otherProps} />;
};

// Flex.defaultProps = {
//   autoWidth: true,
// };

export default Flex;